import { ContainerNode } from 'preact';
import { render } from "preact/compat";
import { schema } from './config'
import { App } from './main';
import { MessageApp } from './message';


class betSlips {
    bsDebug = false;
    bsContainer = '';
    bsToggle: string | null = null;
    bsSport: string | null = null;
    bsLanguage = 'en';
    bsAPIUrl: string;
    bsCookieModal: string;
    bsCookieLength: number;
    bsExperiment: string | null = null;
    bsTrigger: string | null = null;
    bsOnBoardingModal: boolean = false;
    constructor(settings: schema) {
        this.bsDebug = settings.bsDebug;
        this.bsContainer = settings.bsContainer;
        this.bsToggle = settings.bsToggle;
        this.bsSport = settings.bsSport;
        this.bsLanguage = settings.bsLanguage;
        this.bsAPIUrl = settings.bsAPIUrl;
        this.bsCookieModal = settings.bsCookieModal;
        this.bsCookieLength = settings.bsCookieLength;
        this.bsExperiment = settings.bsExperiment;
        this.bsTrigger = settings.bsTrigger;
        this.bsOnBoardingModal = settings.bsOnBoardingModal;
    }
    modal() {
        const element: ContainerNode = document.getElementById(this.bsContainer) as HTMLElement;
        document.body.classList.add("bs-open", "modal-open")

        render(MessageApp, element)
    }
    init () {
        const element: ContainerNode = document.getElementById(this.bsContainer) as HTMLElement;

        render(App, element);
    }
    destroy() {
        const element: ContainerNode = document.getElementById(this.bsContainer) as HTMLElement;

        render(null, element)
    }
}

export default betSlips